import styled, { keyframes } from "styled-components";
import { ITheme } from "../Theme/Theme.types.js";
import { DefaultSkeletonProps, SkeletonColor, SkeletonProps, SkeletonRadius } from "./Skeleton.types.js";

const skeletonColorMap = ({ theme }: { theme: ITheme }): Record<SkeletonColor, string> => ({
    [SkeletonColor.GLASS]: theme.grayscale.whiteGlass,
    [SkeletonColor.GREY]: theme.grayscale[30],
    [SkeletonColor.LIGHTGREY]: theme.grayscale[20],
    [SkeletonColor.TRANSPARENT]: "transparent",
});

const skeletonRadiusMap = ({ theme }: { theme: ITheme }): Record<SkeletonRadius, string> => ({
    [SkeletonRadius.MAX]: theme.radius.round,
    [SkeletonRadius.LARGE]: theme.radius.xl,
    [SkeletonRadius.MEDIUM]: theme.radius.s,
    [SkeletonRadius.SMALL]: theme.radius.xxs,
});

const shimmer = keyframes`
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
`;

export const StyledSkeleton = styled.div<SkeletonProps & DefaultSkeletonProps>`
    position: relative;
    overflow: hidden;
    background-color: ${(props) => skeletonColorMap({ theme: props.theme })[props.color]};
    border-radius: ${(props) => skeletonRadiusMap({ theme: props.theme })[props.radius]};
    height: ${(props) => props.height};
    width: ${(props) => props.width};

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.4) 50%, transparent 100%);
        animation: ${shimmer} 2s infinite;
    }
`;
